import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { BrowserModule } from "@angular/platform-browser";
import { HashLocationStrategy, LocationStrategy } from "@angular/common";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { AppNotfoundComponent } from "./air/pages/notfound/app.notfound.component";
import { AppMaintenanceComponent } from "./air/pages/maintain/app.maintenance";
import { AppErrorComponent } from "./air/pages/error/app.error.component";
import { AppAccessdeniedComponent } from "./air/pages/access/app.accessdenied.component";
import { AppLoginComponent } from "./air/pages/auth/login/app.login.component";
import { NgHttpLoaderModule } from "ng-http-loader";
import { HighchartsChartModule } from "highcharts-angular";
import { ForgetPasswordComponent } from "./air/pages/auth/forget-password/forget-password.component";
import { PasswordConfirmComponent } from "./air/pages/auth/password-confirm/password-confirm.component";
import { ResendComponent } from "./air/pages/auth/resend/resend.component";
import { ResetPasswordComponent } from "./air/pages/auth/reset-password/reset-password.component";
import { ResetPasswordAuthComponent } from "./air/pages/auth/reset-password-auth/reset-password-auth.component";


import { AppAssociationComponent } from './air/pages/association/app.association.component';
import { AppEndUserLicenseAgreementComponent } from "./air/pages/end-user-license-agreement/app.end-user-license-agreement.component";
import { AngularDraggableModule } from "angular2-draggable";
import { ClipboardModule } from '@angular/cdk/clipboard';
import { DatePipe } from '@angular/common';
import { AirModule } from "./air/air.module";
import { SliderModule } from "primeng/slider";
import { PrimengModule } from "./air/modules/primeng/primeng.module";
import { DirectLinkComponent } from './direct-link/direct-link.component';
import { DirectLinkShipmentTrackingDetailsComponent } from './direct-link/direct-link-shipment-tracking-details/direct-link-shipment-tracking-details.component';
import { DirectLinkTimelineComponent } from './direct-link/direct-link-timeline/direct-link-timeline.component';
import { DirectLinkListDetailsComponent } from './direct-link/direct-link-list-details/direct-link-list-details.component';
import { DirectLinkTopbarComponent } from "./direct-link/direct-link-topbar/direct-link-topbar.component";
import { AppFooterComponent } from "./air/modules/common/component/footer/app.footer.component";
import { providePrimeNG } from "primeng/config";
import { MyPreset } from "../styles";
import { InputSwitchModule } from "primeng/inputswitch";
import { AccordionModule } from "primeng/accordion";



@NgModule({
    declarations: [
        AppAccessdeniedComponent,
        AppAssociationComponent,
        AppComponent,
        AppErrorComponent,
        AppEndUserLicenseAgreementComponent,
        AppLoginComponent,
        AppNotfoundComponent,
        AppMaintenanceComponent,
        ForgetPasswordComponent,
        PasswordConfirmComponent,
        ResendComponent,
        ResetPasswordComponent,
        ResetPasswordAuthComponent,
        DirectLinkShipmentTrackingDetailsComponent,
        DirectLinkTimelineComponent,
        DirectLinkComponent,
        DirectLinkShipmentTrackingDetailsComponent,
        DirectLinkListDetailsComponent,
        DirectLinkTopbarComponent,
        //   AppFooterComponent
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [FormsModule],
    imports: [SliderModule,
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        PrimengModule,
        HighchartsChartModule,
        NgHttpLoaderModule.forRoot(),
        AngularDraggableModule,
        ClipboardModule,
        DatePipe,
        AccordionModule,
        FormsModule,      
        InputSwitchModule,
        AirModule],
    providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy },
        ErrorHandler,
        DatePipe,
    providePrimeNG({
        ripple: true,
        theme: {
            preset: MyPreset,
            options: {
                prefix: 'p',
                cssLayer: false,
                darkModeSelector: false || 'none'
            }
        }
    }),
    provideHttpClient(withInterceptorsFromDi())]
})
export class AppModule { }
